module.exports = __webpack_public_path__ + "static/media/arrowProject.86423ab7.svg";